import React from "react";
import styles from "./RawFallback.module.css";

const RawFallback = ({ rawText, accentColor = "#22c55e" }) => {
  if (!rawText || rawText.trim().length < 80) return null;
  return (
    <div className={styles.rawFallback} style={{ "--accent": accentColor }}>
      <p className={styles.rawFallbackNote}>
        Displaying raw analysis (structured parsing did not match the response format)
      </p>
      <pre className={styles.rawFallbackContent}>{rawText.trim()}</pre>
    </div>
  );
};

export default RawFallback;
